import Link from 'next/link'
import Image from 'next/image'
import { cloudfront } from "../../config"
import { truncateString }  from "../utils"
import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import projectStyles from '../../styles/Projects.module.css'
import ProjectDownHeart from "./ProjectDownHeart"
import ProjectPubPoints from "./ProjectPubPoints"
const { convert } = require('html-to-text');

export default function ProjectItem(props) {
    return(
            <Col md={12} lg={4} className="mb-4">
                <Card className="h-100 shadow-sm p-2 card-hover">
                    <Link href={`/project/${props.project.id}`} passHref>
                        <a>
                            <Image className={projectStyles.thumbnail} src={`${cloudfront}/media/${props.project.thumbnail}`} width={310} height={147} layout='responsive' alt={props.project.name} />
                        </a>
                    </Link>
                    
                        <Card.Body>
                            <Link href={`/project/${props.project.id}`} passHref>
                                <a className={projectStyles.project_link}>
                                <Card.Title className={projectStyles.title}>{props.project.name}</Card.Title>
                                <div className="text-dark">
                                    <ProjectPubPoints date={props.project.upload_date} points={props.project.point_cost} />
                                    <p>{truncateString(convert(String(props.project.summary)), 100)}</p>
                                </div>
                                </a>
                            </Link>    
                                <ProjectDownHeart  
                                    id={props.project.id} 
                                    downloads={props.project.downloads} 
                                    votes={props.project.votes} 
                                    user={props.user}
                                    setRegisterModal={props.setRegisterModal}
                                    like={props.like}
                                    handleLikes={props.handleLikes}
                                    profileId={props.profileId}
                                />
                        </Card.Body>
                </Card>
            </Col>
    )
}